import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { setToken } from '@/lib/auth';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    const target = location.pathname && location.pathname !== '/' && location.pathname !== '/login' ? location.pathname : '/dashboard';
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'X-Session-ID': sessionId },
          credentials: 'include',
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.access_token) throw new Error(data.detail || 'Google sign-in failed');
        setToken(data.access_token);
        window.history.replaceState(null, '', target);
        navigate(data.is_admin ? '/admin' : target, { replace: true, state: { user: data.user } });
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-100" data-testid="auth-callback">
      {error ? (
        <div className="text-center space-y-4">
          <p className="text-rose-300" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => { window.history.replaceState(null, '', '/login'); navigate('/login', { replace: true }); }} className="rounded-full bg-amber-500 px-5 py-2 font-semibold text-slate-950" data-testid="auth-callback-retry">
            Back to sign in
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-slate-300"><Loader2 className="h-5 w-5 animate-spin text-amber-400" /> Completing Google sign-in…</div>
      )}
    </div>
  );
}
